import {api} from './api';

export const donationService = {
  async createCheckoutSession(
    amountCents: number,
    successUrl?: string,
    cancelUrl?: string,
  ): Promise<{url: string}> {
    return api.post<{url: string}>('/api/v1/donations/create-checkout-session', {
      amountCents,
      ...(successUrl && {successUrl}),
      ...(cancelUrl && {cancelUrl}),
    });
  },
};
